<template>

  <Modal
    :title="title"
    @close="cancel"
    min-height="300px"
    max-width="640px">
    <template slot="body">
      <div
        v-for="field in fieldSchema"
        :key="field.key"
        class="form-group">
        <label>
          {{ field.name }}
          <span v-if="field.required" class="text-danger">*</span>
        </label>

        <v-select
          v-if="field.type === 'select'"
          :value="selectedOption(field)"
          :options="field.options"
          label="title"
          @input="onSelect(field, $event)" />

        <input
          v-else
          type="text"
          class="form-control"
          v-model="params[field.key]"
          :maxlength="field.maxLength" />

        <ValidateMessage :error="validationErrors ? validationErrors[`extra_fields.${field.key}`] : null" />
      </div>
    </template>
    <template
      slot="footer">
      <div
        :class="{'box-loading': loading}">
        <button
          type="button"
          class="btn btn-light"
          @click="cancel">{{ $t('Cancel') }}</button>
        <button
          type="button"
          class="btn btn-primary"
          @click="save">{{ $t('Save') }}</button>
      </div>
    </template>
  </Modal>

</template>

<script>
import Modal from '@/components/Modal/Modal'

export default {
  name: 'JobAdvertiseBoardsItemForm',
  components: {
    Modal
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    fieldSchema: {
      type: Array,
      default: () => []
    },
    validationErrors: {
      type: Object,
      default: () => null
    },
    initParams: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      params: this.$clone(this.initParams)
    }
  },
  methods: {
    /*
    selectedOption: encontra o objeto { title, value } correspondente ao valor
    guardado em params[field.key] para o v-select exibir o título selecionado
    */
    selectedOption (field) {
      const value = this.params[field.key]
      return (field.options || []).find(option => option.value === value) || null
    },
    /*
    onSelect: grava apenas o value da opção selecionada (vue-select v2 emite o objeto)
    */
    onSelect (field, option) {
      this.$set(this.params, field.key, option ? option.value : null)
    },
    cancel () {
      this.$emit('cancel')
    },
    save () {
      this.$emit('save', this.params)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobAdvertise/JobAdvertiseBoardsItemForm.vue